module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-popup-0db57a0d05d51e95f04e8ecd432488b3.gif";